/*******************************************************************************
BUILD A ITEM EDIT MODAL WINDOW
*******************************************************************************/

export default function buildConfirmationModal(options) {
    const { title, message, cancelButton, itemID, confirmClass, confirmButton, includeBackground } = options;

    const modalHTML = `
    <div class="modal">
        <div class="modal__head">${title}</div>
        <div class="modal__main">
            <div class="modal__message">${message}</div>
            <div class="modal__actions">
                <button class="close-modal btn size-1 pad-2 outline upper">${cancelButton}</button>
                <button data-itemid="${itemID}" data-inprogress="Working..." class="${confirmClass} btn size-1 pad-2 danger upper bold">${confirmButton}</button>
            </div>
        </div>
    </div>`;

    return (includeBackground === 'Yes') ? `<div class="modal-background">${modalHTML}</div>` : modalHTML;
}
